import { memo } from 'react';
import { Icon } from '@cbhq/cds-web/icons';
import { HStack } from '@cbhq/cds-web/layout';
import { Tooltip } from '@cbhq/cds-web/overlays';
import { TextLabel1, TextTitle1, TextTitle3 } from '@cbhq/cds-web/typography';
import { ListCell } from '@cbhq/cds-web/cells/ListCell';
import { DisplayType, format } from '@/utils/numberFormatter';
import SummaryCard from './SummaryCard';

type EarnCardProps = {
  totalApr: number;
  tradingFee: number;
};

const EarnCard = memo(function EarnCard({ totalApr, tradingFee }: EarnCardProps) {
  const header = (
    <TextTitle3 as="h2" testID="earn-card-title">
      Earn
    </TextTitle3>
  );

  return (
    <SummaryCard header={header}>
      <ListCell
        title={
          <HStack gap={0.5} alignItems="center">
            <TextLabel1 as="p" color="fgMuted">
              Total APR
            </TextLabel1>
            <Tooltip content="Annualized based on 7-day fees">
              <Icon name="info" size="xs" color="fgMuted" />
            </Tooltip>
          </HStack>
        }
        description={
          <TextTitle1 as="h3">
            {format({ value: totalApr, type: DisplayType.Percentage })}
          </TextTitle1>
        }
      />
      <ListCell
        title={
          <HStack gap={0.5} alignItems="center">
            <TextLabel1 as="p" color="fgMuted">
              Trading Fee
            </TextLabel1>
            <Tooltip content="Fee for using the liquidity pool to execute trades">
              <Icon name="info" size="xs" color="fgMuted" />
            </Tooltip>
          </HStack>
        }
        description={
          <TextTitle1 as="h3">
            {format({ value: tradingFee, type: DisplayType.Percentage })}
          </TextTitle1>
        }
      />
    </SummaryCard>
  );
});

export default EarnCard;
